import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MostPopularService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getData(){
        let url = `${this.API_URL}/tutorials?filters[mostPopular][$eq]=true&sort=id:DESC&populate=*`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

}